import gql from 'graphql-tag';

export const GET_CREDIT_WALLET = gql`
  query CreditWallets($first: Int!, $after: String) {
    me {
      id
      creditWallet {
        id
        pointBalance
        totalPointsEarned
        events(after: $after, first: $first) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              date
              type
              amount
              id
              user {
                id
                publicName
              }
              order {
                id
                number
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_REFERRALS = gql`
  query UserReferrals($first: Int!, $after: String) {
    me {
      id
      numJoinedReferrals
      numPurchasedReferrals
      referrals(after: $after, first: $first) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            created
            referred {
              id
              email
            }
            status
          }
        }
      }
    }
  }
`;

export const GET_REFERRAL_STRING = gql`
  query GetUserDetails {
    me {
      id
      referralString
    }
  }
`;

export const GET_USER_ID = gql`
  query GetUserId {
    me {
      id
    }
  }
`;
